<template src='./CreacionHorarios.html'></template>
<script>
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/es.js";
import "vue-cal/dist/vuecal.css";
import DatePicker from "../DatePicker/Datepicker";
import FormularioDialogoSecciones from "../FormularioDialogoSecciones/FormularioDialogoSecciones"
import Icono from "../Icono/Icono";
import moment from "moment-timezone";
const moment_tz = require("moment-timezone");
import metodos_comunes from "../../js/metodos_comunes";
import {
  consultarEsquemaCreacionHorarios,
  consultarAgenda,
  crearHorario,
  actualizarHorario,
  eliminarHorario,
  actualizarSubhorario
} from "../../apiService/request/Calendario";

export default {
  data() {
    return {
 
      weekNumbers: false,
      snapToTime: 5,
      mostrarFiltroHorarios: true,
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      agenda: [],
      informacionInicialAgenda: [],
      filtrosConsulta: [],
      on: true,
      today: moment()
        .tz("America/Bogota")
        .format("YYYY-MM-DD HH:mm:ss"),
      fechaConsulta: "",
      selectedEvent: {},
      showDialog: false,
      iconoBot:
        "M22,0C9.9,0,0,9.9,0,22s9.9,22,22,22s22-9.9,22-22S34.1,0,22,0z M22,2c8,0,14.9,4.7,18.1,11.5C36.1,7.7,29.4,4,22,4C14.6,4,7.9,7.7,3.9,13.5C7.1,6.7,14,2,22,2z M41.6,22C39.7,31.3,31.5,38,22,38S4.3,31.3,2.4,22C4.3,12.7,12.5,6,22,6S39.7,12.7,41.6,22z M22,42c-8,0-14.9-4.7-18.1-11.5C7.9,36.3,14.6,40,22,40c7.4,0,14.1-3.7,18.1-9.5C36.9,37.3,30,42,22,42z M13,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S16.3,16,13,16z M13,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S15.2,26,13,26z M31,16c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S34.3,16,31,16z M31,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S33.2,26,31,26z",
      iconoBuscar:
        "M17.8,27.8c0,0.6-0.4,1-1,1c-6.7,0-12.1-5.4-12.1-12.1c0-0.6,0.4-1,1-1s1,0.4,1,1c0,5.6,4.5,10.1,10.1,10.1C17.3,26.8,17.8,27.3,17.8,27.8z M43.7,43.7C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L27.8,29.3c-3,2.6-6.8,4.2-11.1,4.2C7.5,33.5,0,26,0,16.8S7.5,0,16.8,0s16.8,7.5,16.8,16.8c0,4.3-1.6,8.1-4.2,11.1l14.4,14.4C44.1,42.7,44.1,43.3,43.7,43.7zM16.8,31.5c8.1,0,14.8-6.6,14.8-14.8S24.9,2,16.8,2S2,8.6,2,16.8S8.6,31.5,16.8,31.5z",
      estructuraEvento: {
        start: "",
        end: "",
        title: "Nuevo evento",
        icon: "",
        content: "",
        contentFull: "",
        class: "",
        sede: "",
        nombrePrestacion: "",
        duracion: "",
        espacio: "",
        responsable: "",
        estado: ""
      },
      indexElementoSeleccionado: Number,
      events: [],
      nuevoBloque: {},
      variablesEventoSeleccionado: [],
      cantidaElementosMostrar: 0,
      renderizar: 0,
      mensajeRespuestaEnpoint: {},
      arraySubhorarios: [],
      arrayHoras: [],
      rulesHoraInicio: [],
      rulesHoraFinal: [],
      valid: false,
      esquemaCrearHorariosExcel:{},

    };
  },
  components: { VueCal, DatePicker, Icono,FormularioDialogoSecciones },
  created() {
    // this.formularioPruebaLista=this.listasDependientesDeListas(this.formularioPruebaLista)
    // this.construirArrayListasDependientes()
    this.obtenerEsquemasCreacionHorarios("parametros_iniciales_horarios");
    this.obtenerEsquemasCreacionHorariosNuevos("creacion_de_horarios");
    this.obtenerEsquemaCrearHorarioExcel()
    // console.log('filtrosConsulta',this.filtrosConsulta)
  },
  beforeUpdate() {
    console.log("eventos", this.events);
  },
  props: ["valorSeleccionadoDialogo"],
  watch: {
    showDialog(newValue, oldValue) {
      if (newValue == false) {
        this.consutarAgendaCreacionHorarios();
      } else {
        this.selected = [];
      }
    },
    valorSeleccionadoDialogo(valor) {
      if (valor == "Si") {
        this.eliminar();
      }
    }
  },
  methods: {
    async obtenerEsquemaCrearHorarioExcel(){
        try{
            this.esquemaCrearHorariosExcel=(await consultarEsquemaCreacionHorarios("carga_agenda")).data.data.data[0]
        }finally{
            
        }
    },
    async obtenerEsquemasCreacionHorarios(key) {
      try {
        this.$store.dispatch("setCargando", true);
        this.filtrosConsulta = (
          await consultarEsquemaCreacionHorarios(key)
        ).data.data.data;
        this.filtrosConsulta[0].variables[2].valor = Number(
          moment()
            .tz("America/Bogota")
            .format("x")
        );
        console.log(
          "esquema",
          this.filtrosConsulta,
          moment()
            .tz("America/Bogota")
            .format("x")
        );
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async obtenerEsquemasCreacionHorariosNuevos(key) {
      try {
        this.$store.dispatch("setCargando", true);
        this.nuevoBloque = (
          await consultarEsquemaCreacionHorarios(key)
        ).data.data.data[0];
        console.log("esquemaNuevo", this.nuevoBloque);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async consutarAgendaCreacionHorarios() {
      this.arraySubhorarios = [];
      this.arrayHoras = [];
      const lodashClonedeep = require("lodash.clonedeep");
      try {
        this.$store.dispatch("setCargando", true);
        this.agenda = (
          await consultarAgenda(this.filtrosConsulta[0])
        ).data.data.data;
        this.informacionInicialAgenda = lodashClonedeep(this.agenda);
        console.log("agenda", this.agenda, this.informacionInicialAgenda);
        this.crearArrayEventos(this.agenda);
      } finally {
        this.$store.dispatch("setCargando", false);
        this.today = moment(this.filtrosConsulta[0].variables[2].valor)
          .tz("America/Bogota")
          .format("YYYY-MM-DD hh:mm:ss");
        this.mostrarFiltroHorarios = false;
      }
    },
    guardar() {
      // if (this.$refs.form.validate()) {
      this.variablesEventoSeleccionado.map(elemento => {
        if (elemento.tipo == "numero") {
          elemento.valor = Number(elemento.valor);
        }
      });
      console.log(
        "actualizarEvento:",
        this.variablesEventoSeleccionado,
        this.indexElementoSeleccionado,
        this.events[this.indexElementoSeleccionado].accion
      );
      if (this.events[this.indexElementoSeleccionado].accion == "creacion") {
        let bloqueACrear = this.nuevoBloque;
        bloqueACrear.variables = this.variablesEventoSeleccionado;
        this.crearNuevoBloqueHorario(bloqueACrear);
      } else if (
        this.events[this.indexElementoSeleccionado].accion == "edicion"
      ) {
        let bloqueAActualizar = this.agenda[this.indexElementoSeleccionado];
        bloqueAActualizar.variables = this.variablesEventoSeleccionado;
        this.actualizarHorarioExistente(bloqueAActualizar);
      }

      // }
    },
    eliminar() {
      let bloqueAEliminar = this.agenda[this.indexElementoSeleccionado];
      bloqueAEliminar.variables = this.variablesEventoSeleccionado;
      console.log("bloqueAEliminar:", bloqueAEliminar);
      this.eliminarBloqueHorario(bloqueAEliminar);
    },
    async confirmaEliminarHorario() {
      const dialogoModal = {
        dialogo: true,
        mensaje: `¿Está seguro de que desea eliminar este horario?`,
        opciones: ["Si", "No"],
        status: 200
      };
      this.$store.dispatch("cambiarEstadoModal", true);
      this.$store.dispatch("cambiarMensajeModal", dialogoModal);
    },
    async crearNuevoBloqueHorario(formulario) {
      try {
        this.$store.dispatch("setCargando", true);
        this.mensajeRespuestaEnpoint = await crearHorario(formulario);
      } finally {
        this.$store.dispatch("setCargando", false);

        const dialogoModal = {
          status: this.mensajeRespuestaEnpoint.data.status,
          dialogo: false,
          data: {
            message: this.mensajeRespuestaEnpoint.data.message
          }
        };
        if (dialogoModal.status == 200) {
          this.showDialog = false;
          this.consutarAgendaCreacionHorarios();
        }
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", dialogoModal);
        this.obtenerEsquemasCreacionHorariosNuevos("creacion_de_horarios");
      }
    },
    async actualizarHorarioExistente(bloqueAActualizar) {
      console.log(
        "datos actualizar:",
        this.informacionInicialAgenda,
        bloqueAActualizar.variables
      );
      try {
        this.$store.dispatch("setCargando", true);
        this.mensajeRespuestaEnpoint = await actualizarHorario(
          this.informacionInicialAgenda[this.indexElementoSeleccionado],
          bloqueAActualizar
        );
      } finally {
        this.$store.dispatch("setCargando", false);
        this.consutarAgendaCreacionHorarios();
        // this.showDialog = false
        const dialogoModal = {
          status: this.mensajeRespuestaEnpoint.data.status,
          dialogo: false,
          data: {
            message: this.mensajeRespuestaEnpoint.data.message
          }
        };
        if (dialogoModal.status == 200) {
          this.showDialog = false;
          this.consutarAgendaCreacionHorarios();
        }
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      }
    },
    async eliminarBloqueHorario(formulario) {
      try {
        this.$store.dispatch("setCargando", true);
        this.mensajeRespuestaEnpoint = await eliminarHorario(formulario);
      } finally {
        this.$store.dispatch("setCargando", false);
        // this.showDialog = false
        const dialogoModal = {
          status: this.mensajeRespuestaEnpoint.data.status,
          dialogo: false,
          data: {
            message: this.mensajeRespuestaEnpoint.data.message
          }
        };
        if (dialogoModal.status == 200) {
          this.showDialog = false;
          this.consutarAgendaCreacionHorarios();
        }
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      }
    },
    calcularCantidadSeleccionada(arrayValores, formulario, index) {
      this.posicionSeleccionLista(formulario, index);
      let maximaLongitud = 0;
      arrayValores.map(variable => {
        if (variable.length >= maximaLongitud) {
          maximaLongitud = variable.length;
          if (maximaLongitud >= 7) {
            this.cantidaElementosMostrar = 0;
          } else if (maximaLongitud >= 4 && maximaLongitud < 7) {
            this.cantidaElementosMostrar = 1;
          } else {
            this.cantidaElementosMostrar = 2;
          }
        }
      });
      return arrayValores;
    },
    posicionSeleccionLista(formulario, index) {
      // console.log('formulario:', formulario)
      formulario[index].seleccion = {
        lista: formulario[index].lista,
        valor: formulario[index].valor
      };
      this.variablesEventoSeleccionado = formulario;
      // this.$store.dispatch("setVariablesFormularios", formulario);
      this.construccionOpcionesLista(index);
    },
    construccionOpcionesLista(index) {
      const condiciones = this.variablesEventoSeleccionado[index].seleccion;
      const arrayVariables = this.variablesEventoSeleccionado;
      const self = this;
      arrayVariables.map((elemento, index1) => {
        if (elemento.indexPadre == index) {
          elemento.valor = null;
          self.posicionSeleccionLista(arrayVariables, index1);
          elemento.lista_seleccionada = elemento.opciones_lista.filter(x =>
            x.condiciones.some(
              e =>
                metodos_comunes.reemplazarCaracteresEspeciales(e.lista) ===
                  metodos_comunes.reemplazarCaracteresEspeciales(
                    condiciones.lista
                  ) &&
                metodos_comunes.reemplazarCaracteresEspeciales(e.valor) ===
                  metodos_comunes.reemplazarCaracteresEspeciales(
                    condiciones.valor
                  )
            )
          );
          elemento.habilitado = self.habilitarSelect(
            elemento.lista_seleccionada
          );
        }
      });
      this.variablesEventoSeleccionado = arrayVariables;
      this.renderizar += 1;
    },
    habilitarSelect(lista_seleccionada) {
      if (lista_seleccionada.length > 0) {
        return true;
      }
      return false;
    },
    crearArrayEventos(respuesta) {
      // console.log('respuesta:',respuesta);
      this.events = [];
      let jsonEvento = {};
      const self = this;
      respuesta.map(function(formulario, index) {
        // console.log('formulario:',formulario);
        let jsonEvento = {};
        jsonEvento.index = index;
        jsonEvento.accion = formulario.accion;
        jsonEvento.variables = formulario.variables;
        // jsonEvento.titleEditable= true
        // console.log('jsonEvento:',jsonEvento);
        formulario.variables.map(elemento => {
          console.log("elemento", elemento);

          if (elemento.nombre == "Fecha hora inicio") {
            jsonEvento.horaInicio = moment(elemento.valor)
              .tz("America/Bogota")
              .format("HH:mm");
            jsonEvento.start = moment(elemento.valor)
              .tz("America/Bogota")
              .format("YYYY-MM-DD HH:mm");
          }
          if (elemento.nombre == "Fecha hora final") {
            jsonEvento.horaFinal = moment(elemento.valor)
              .tz("America/Bogota")
              .format("HH:mm");
            jsonEvento.end = moment(elemento.valor)
              .tz("America/Bogota")
              .format("YYYY-MM-DD HH:mm");
          }
          if (elemento.nombre == "Nombre Evento") {
            jsonEvento.title = elemento.valor;
          }
          if (elemento.nombre == "Estado") {
            jsonEvento.class = elemento.valor;
          }
        });
        self.events.push(jsonEvento);
        // console.log('jsonEvento_Final:',jsonEvento,self.events);
      });
    },
    cambiarFechaInicio() {
      const variable =
        this.events[this.indexElementoSeleccionado].start.slice(0, 11) +
        this.events[this.indexElementoSeleccionado].horaInicio;
      this.events[this.indexElementoSeleccionado].start =
        this.events[this.indexElementoSeleccionado].start.slice(0, 11) +
        this.events[this.indexElementoSeleccionado].horaInicio;
      this.events[this.indexElementoSeleccionado].variables[0].valor = Number(
        moment_tz.tz(variable, "YYYY-MM-DD HH:mm", "America/Bogota").format("x")
      );
    },
    cambiarFechaFinal(valor) {
      const variable =
        this.events[this.indexElementoSeleccionado].end.slice(0, 11) +
        this.events[this.indexElementoSeleccionado].horaFinal;
      this.events[this.indexElementoSeleccionado].end =
        this.events[this.indexElementoSeleccionado].end.slice(0, 11) +
        this.events[this.indexElementoSeleccionado].horaFinal;
      this.events[this.indexElementoSeleccionado].variables[1].valor = Number(
        moment_tz
          .tz(
            this.events[this.indexElementoSeleccionado].end,
            "YYYY-MM-DD HH:mm",
            "America/Bogota"
          )
          .format("x")
      );
    },
    actualizarFechaHora() {
      const self = this;
      this.events[this.indexElementoSeleccionado].variables.map(elemento => {
        if (elemento.nombre == "Fecha hora inicio") {
          self.events[self.indexElementoSeleccionado].horaInicio = moment(
            elemento.valor
          )
            .tz("America/Bogota")
            .format("HH:mm");
          self.events[self.indexElementoSeleccionado].start = moment(
            elemento.valor
          )
            .tz("America/Bogota")
            .format("YYYY-MM-DD HH:mm");
        }
        if (elemento.nombre == "Fecha hora final") {
          self.events[self.indexElementoSeleccionado].horaFinal = moment(
            elemento.valor
          )
            .tz("America/Bogota")
            .format("HH:mm");
          self.events[self.indexElementoSeleccionado].end = moment(
            elemento.valor
          )
            .tz("America/Bogota")
            .format("YYYY-MM-DD HH:mm");
        }
      });
    },
    onEventClick(event, e) {
      this.indexElementoSeleccionado = event.index;
      this.variablesEventoSeleccionado = this.events[
        this.indexElementoSeleccionado
      ].variables;
      this.selectedEvent = event;
      this.showDialog = true;
      e.stopPropagation();
      console.log(
        "EVENTO SELECCIONADO:",
        event,
        e,
        this.indexElementoSeleccionado,
        this.variablesEventoSeleccionado
      );
    },
    cellClickHold(event) {
      // console.log('EVENTO SELECCIONADO 2:',event);
      this.indexElementoSeleccionado = event.index;
      this.events[this.indexElementoSeleccionado].variables[0].valor = Number(
        moment_tz
          .tz(event.start, "YYYY-MM-DD HH:mm", "America/Bogota")
          .format("x")
      );
      this.events[this.indexElementoSeleccionado].variables[1].valor = Number(
        moment_tz
          .tz(event.end, "YYYY-MM-DD HH:mm", "America/Bogota")
          .format("x")
      );
      if (this.events[this.indexElementoSeleccionado].accion == "edicion") {
        this.guardar();
      }
    },
    onEventDrop(event) {
      // console.log('EVENTO SELECCIONADO drop1:',event.event);
      this.indexElementoSeleccionado = event.event.index;
      this.events[this.indexElementoSeleccionado].start = event.event.start;
      this.events[this.indexElementoSeleccionado].end = event.event.end;
      this.actualizarVariablesHoras();
      this.consutarAgendaCreacionHorarios();
    },
    eventDurationChange(event) {
      // console.log('EVENTO SELECCIONADO resize:',event);
      this.indexElementoSeleccionado = event.index;
      this.events[this.indexElementoSeleccionado].start = event.start;
      this.events[this.indexElementoSeleccionado].end = event.end;
      this.actualizarVariablesHoras();
    },
    actualizarVariablesHoras() {
      this.events[this.indexElementoSeleccionado].variables[0].valor = Number(
        moment_tz
          .tz(
            this.events[this.indexElementoSeleccionado].start,
            "YYYY-MM-DD HH:mm",
            "America/Bogota"
          )
          .format("x")
      );
      this.events[this.indexElementoSeleccionado].variables[1].valor = Number(
        moment_tz
          .tz(
            this.events[this.indexElementoSeleccionado].end,
            "YYYY-MM-DD HH:mm",
            "America/Bogota"
          )
          .format("x")
      );
      this.variablesEventoSeleccionado = this.events[
        this.indexElementoSeleccionado
      ].variables;
      this.guardar();
    },
    onEventCreate(event, deleteEventFunction) {
      console.log("EVENTO SELECCIONADO 3:", event);
      this.filtrosConsulta[0].variables[2].valor = Number(
        moment_tz
          .tz(event.start, "YYYY-MM-DD HH:mm", "America/Bogota")
          .format("x")
      );
      this.today = event.start;
      let estructuraEventoNuevo = this.nuevoBloque;
      const self = this;
      this.filtrosConsulta[0].variables.map(elemento => {
        estructuraEventoNuevo.variables.map((elemento2, index) => {
          if (
            metodos_comunes.reemplazarCaracteresEspeciales(elemento.nombre) ==
            metodos_comunes.reemplazarCaracteresEspeciales(elemento2.nombre)
          ) {
            elemento2.valor = elemento.valor;
            if (
              elemento2.tipo == "lista" ||
              elemento2.tipo == "array_lista" ||
              elemento2.tipo == "array_listas"
            ) {
              self.posicionSeleccionLista(
                estructuraEventoNuevo.variables,
                index
              );
            }
          }
        });
      });
      estructuraEventoNuevo.variables[0].valor = Number(
        moment_tz
          .tz(event.start, "YYYY-MM-DD HH:mm", "America/Bogota")
          .format("x")
      );
      estructuraEventoNuevo.variables[1].valor = Number(
        moment_tz
          .tz(event.end, "YYYY-MM-DD HH:mm", "America/Bogota")
          .format("x")
      );
      (estructuraEventoNuevo.variables[8].valor = this.$store.state.provider_email),
        console.log("estructuraEventoNuevo:", estructuraEventoNuevo);
      this.agenda.push(estructuraEventoNuevo);
      this.crearArrayEventos(this.agenda);
    },
    crearSubhorario() {
      const lodashClonedeep = require("lodash.clonedeep");
      let nuevoSubhorario = this.agenda[this.indexElementoSeleccionado];
      nuevoSubhorario.variables = this.variablesEventoSeleccionado;
      // this.rules = [
      //     value => !!value || 'Required.',
      //     // value => (Number(moment_tz.tz((value),'HH:mm', 'America/Bogota').format('x')) && Number(moment_tz.tz((value),'HH:mm', 'America/Bogota').format('x'))<= nuevoSubhorario.variables[0].valor) || 'Min 3 characters',
      // ]
      let horasSubhorarios = {
        horaInicio: {
          limite: moment(nuevoSubhorario.variables[0].valor)
            .tz("America/Bogota")
            .format("HH:mm"),
          valor: moment(nuevoSubhorario.variables[0].valor)
            .tz("America/Bogota")
            .format("HH:mm")
        },
        horaFinal: {
          limite: moment(nuevoSubhorario.variables[1].valor)
            .tz("America/Bogota")
            .format("HH:mm"),
          valor: moment(nuevoSubhorario.variables[1].valor)
            .tz("America/Bogota")
            .format("HH:mm")
        }
      };
      // nuevoSubhorario.infoAdicional={}
      // nuevoSubhorario.infoAdicional.rango =[nuevoSubhorario.variables[0].valor,nuevoSubhorario.variables[1].valor]
      // nuevoSubhorario.infoAdicional.horaInicio =nuevoSubhorario.variables[0].valor
      // nuevoSubhorario.infoAdicional.horaFinal =nuevoSubhorario.variables[1].valor

      this.arraySubhorarios.push(lodashClonedeep(nuevoSubhorario));
      this.arrayHoras.push(horasSubhorarios);
      console.log("nuevoSubhorario:", this.arrayHoras, this.arraySubhorarios);
    },
    cambiarHoraInicioSubhorario(index) {
      (this.rulesHoraInicio = [
        v => !!v || "Hora requerida",
        v =>
          (v && v >= this.arrayHoras[index].horaInicio.limite) ||
          "Hora inicial fuera de rango del bloque"
      ]),
        console.log(
          "cambiarHoraInicioSubhorario:",
          this.arrayHoras[index].horaInicio.valor
        );
      const start = moment(this.arraySubhorarios[index].variables[0].valor)
        .tz("America/Bogota")
        .format("YYYY-MM-DD HH:mm");
      const variable =
        start.slice(0, 11) + this.arrayHoras[index].horaInicio.valor;
      this.arraySubhorarios[index].variables[0].valor = Number(
        moment_tz.tz(variable, "YYYY-MM-DD HH:mm", "America/Bogota").format("x")
      );
    },
    cambiarHoraFinalSubhorario(index) {
      this.rulesHoraFinal = [
        v => !!v || "Hora requerida",
        v =>
          (v && v <= this.arrayHoras[index].horaFinal.limite) ||
          "Hora final fuera de rango del bloque"
      ];
      const end = moment(this.arraySubhorarios[index].variables[1].valor)
        .tz("America/Bogota")
        .format("YYYY-MM-DD HH:mm");
      const variable =
        end.slice(0, 11) + this.arrayHoras[index].horaFinal.valor;
      this.arraySubhorarios[index].variables[1].valor = Number(
        moment_tz.tz(variable, "YYYY-MM-DD HH:mm", "America/Bogota").format("x")
      );
    },
    actualizarSubhorario(index) {
      console.log(
        "actualizarSubhorario:",
        index,
        this.arraySubhorarios,
        this.arraySubhorarios[index]
      );

      this.actualizarBloqueSubhorario(this.arraySubhorarios[index]);
    },
    async actualizarBloqueSubhorario(info_nueva) {
      try {
        this.mensajeRespuestaEnpoint = await actualizarSubhorario(
          this.agenda[this.indexElementoSeleccionado],
          info_nueva
        );
      } finally {
        const dialogoModal = {
          status: this.mensajeRespuestaEnpoint.data.status,
          dialogo: false,
          data: {
            message: this.mensajeRespuestaEnpoint.data.message
          }
        };
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", dialogoModal);
      }
    }
  }
};
</script>
<style src='./CreacionHorarios.scss' lang="scss" scoped>
</style>
<style lang="scss" >
@import "../../assets/sass/main";
.v-dialog__content {
  .v-dialog {
    @extend .scrollbar;
    min-width: 580px;
    .colorTituloTarjetaEstados {
      color: gray;
    }
  }
}
.tamanoChip {
  max-width: 70%;
}
// .autocomplete {
// //   margin-top: 12px;
//   border-radius: 24px !important;
//   .v-input__control {
//     .v-input__slot {
//       background-color: #f3f3f3 !important;
//       .v-select__slot {
//           height: 30px;
//         input {
//           color: #2d2d2d !important;
//           font-weight: 600;
//         }
//         .mdi-menu-down::before {
//           color: #3a899a !important;
//           height: 28px;
//           font-size: 28px;
//         }
//       }
//     }
//     .v-text-field__details {
//       padding-left: 3%;
//     }
//   }
// }
// .autocomplete-llenado {
//   border-radius: 24px !important;
//   .v-input__control {
//     .v-input__slot {
//         height: 30px;
//       background-color: #d9edf0 !important;
//       .v-select__slot {
//         input {
//           color: #575757 !important;
//           font-weight: 600;
//         }
//         .mdi-menu-down::before {
//           color: #575757 !important;
//           height: 28px;
//           font-size: 28px;
//         }
//       }
//     }
//     .v-text-field__details {
//       padding-left: 3%;
//     }
//   }
// }
// .theme--light.v-input--is-disabled, .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea{
//     .v-input__control {
//     .v-input__slot {
//       background-color: #f6f3f3 !important;
//       .v-select__slot {
//           height: 30px;
//         input {
//           color: #2d2d2d !important;
//         }
//         .mdi-menu-down::before {
//           color: grey !important;
//           height: 28px;
//           font-size: 28px;
//         }
//       }
//     }
//     .v-text-field__details {
//       padding-left: 3%;
//     }
//   }
// }
// .autocomplete-deshabilitado {
//   .v-input__control {
//     .v-input__slot {
//       background-color: #f3f3f3 !important;
//       .v-select__slot {
//           height: 30px;
//         input {
//           color: #2d2d2d !important;
//         }
//         .mdi-menu-down::before {
//           color: #666666 !important;
//           height: 28px;
//           font-size: 28px;
//         }
//       }
//     }
//     .v-text-field__details {
//       padding-left: 3%;
//     }
//   }
// }

@include pantalla-mediana {
  .tamanoChip {
    max-width: 70%;
  }
  .tamanoSpanAutocomplete {
    width: 20%;
    font-size: 10px;
  }
}
@include pantalla-pequena {
  .tamanoChip {
    max-width: 110px;
  }
  .tamanoSpanAutocomplete {
    width: 20%;
    font-size: 8px;
  }
}

.contenedorCreacionHorarios {
  .vueCal {
    .vuecal__header {
      .vuecal__title-bar {
        background-color: #3f9aae;
        color: white;
      }
    }
    .vuecal__time-column {
      width: 4em;
      text-align-last: center;
    }

    .vuecal__event {
      background-color: #d9edf0;
      cursor: pointer;
    }
    .bloqueado {
      background-color: #ee6975;
      color: white;
    }
    .disponible {
      background-color: #61c8a2;
      color: white;
    }
    .no_disponible {
      background-color: #f4b584;
      color: white;
    }
    .reservado {
      background-color: #5781b1;
      //   border: 1px solid #3F51B6;
      color: white;
    }

    .vuecal__flex {
      .vuecal__bg {
        @extend .scrollbar;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CreacionHorarios/CreacionHorarios.vue